import moment from 'moment'

export default class AutomaticSchedulerEvent {
    public Id?: number;
    public Subject: string;
    public Description: string;
    public Name: string;
    public StartTime: Date;
    public EndTime?: Date;
    public ProjectId: number;
    public TaskId: number;
    public IsBlock: boolean;
    public PrimaryColor: string;
    public SecondaryColor: string;
    public Constraint: string;
    public RecurrenceRule = '';

    constructor(it: any) {
        this.Id = it.Id;
        this.Subject = it.Subject;
        this.Name = it.Name;
        this.StartTime = moment(it.StartTime).toDate();
        this.EndTime = moment(it.EndTime).toDate();
        this.ProjectId = it.ProjectId;
        this.TaskId = it.TaskId;
        this.Description = it.Description;
        this.IsBlock = it.IsBlock;
        this.PrimaryColor = it.PrimaryColor;
        this.SecondaryColor = it.SecondaryColor;
        this.Constraint = it.Constraint;
    }
}
